import { createApp } from '@wu/widget-core';
import { meta } from './constants';
import { Popup } from './Popup';

export default createApp(meta, Popup);
